import { db, Timestamp } from '@/utils/Firebase'
import firebase from 'firebase/app'
import 'firebase/functions'

const COLLECTION = 'aiChats'

/**
 * Carga el historial de mensajes de un chat guardado en Firestore.
 * Formato: aiChats/{coachId}_{studentId}/messages (subcolección)
 */
export function chatDocId(coachId, studentId) {
    return `${coachId}_${studentId}`
}

export async function loadChatHistory(coachId, studentId) {
    if (!coachId || !studentId) return []
    const snap = await db
        .collection(COLLECTION)
        .doc(chatDocId(coachId, studentId))
        .collection('messages')
        .orderBy('createdAt', 'asc')
        .get()

    return snap.docs.map(d => ({ id: d.id, ...d.data() }))
}

export async function saveMessage(coachId, studentId, role, content) {
    if (!coachId || !studentId) return
    const docId = chatDocId(coachId, studentId)

    // Asegurar que el documento padre existe con metadata
    const parentRef = db.collection(COLLECTION).doc(docId)
    await parentRef.set({
        coachId,
        studentId,
        updatedAt: Timestamp.now(),
    }, { merge: true })

    await parentRef.collection('messages').add({
        role,   // 'user' | 'assistant'
        content,
        createdAt: Timestamp.now(),
    })
}

export async function clearChatHistory(coachId, studentId) {
    if (!coachId || !studentId) return
    const messagesRef = db
        .collection(COLLECTION)
        .doc(chatDocId(coachId, studentId))
        .collection('messages')

    const snap = await messagesRef.get()
    const batch = db.batch()
    snap.docs.forEach(d => batch.delete(d.ref))
    await batch.commit()
}


export async function sendMessageToAI(messages, studentContext, locale = 'es', studentId = null) {
    const studentChat = firebase.app().functions('us-central1').httpsCallable('aiStudentChat')
    const result = await studentChat({ messages, studentId, locale })
    return result.data.text
}

/**
 * Construye el contexto del alumno a partir de los datos disponibles
 * en el perfil. Cuando builder-functions esté disponible, esto se
 * moverá al backend como buildStudentContext().
 */
export function buildStudentContext(student, monthRoutines = []) {
    if (!student) return {}

    const completedRoutines = monthRoutines.filter(r => r.status === 'done').length
    const totalRoutines = monthRoutines.length
    const completionRate = totalRoutines > 0
        ? Math.round((completedRoutines / totalRoutines) * 100)
        : null

    const recentWellness = monthRoutines
        .filter(r => r.wellness)
        .slice(-5)
        .map(r => ({
            date: r.date,
            energy: r.wellness?.energy,
            mood: r.wellness?.mood,
            sleep: r.wellness?.sleep,
            pain: r.wellness?.pain,
        }))

    return {
        name: student.name || '',
        email: student.email || '',
        objectives: student.objectives || [],
        injuries: student.injuries || [],
        equipments: student.equipments || [],
        currentMonth: {
            totalRoutines,
            completedRoutines,
            completionRate: completionRate !== null ? `${completionRate}%` : 'sin datos',
            recentWellness,
        },
    }
}
